'use strict';

var App = require('app');
var AppState = require('app_state');
var BaseDeviceController = require('components/devices/controllers/base_device_controller');
var Misc = require('utils/misc');

var BaseFilterController = BaseDeviceController.extend({
    initialize: function (options) {
        options = options || {};
        this.wantAll = options.wantAll || false;
    },

    useDeviceList: function (deviceListFunc, fromFilter) {
        if (this.deviceList) {
            deviceListFunc(fromFilter ? this.filterDeviceList : this.deviceList);
            return;
        }

        var self = this;
        var req = App.request('device:list', {
            filterParams: this.getRequestParams(),
            filter: this.filter,
            columns: this.getColumns(),
            wantAll: this.wantAll,
            isFilter: true,
        });
        $.when(req).done(function (data) {
            self.deviceList = data;
            self.filterDeviceList = data;
            deviceListFunc(data);
        });
    },

    getColumns: function () {
        return undefined;
    },

    getRequestParams: function () {
        return {};
    },

    setFilter: function (filter) {
        this.filter = filter;
        this.filterDeviceList = undefined;
        this.deviceList = undefined;
    },

    getCSVLink: function () {
        if (!this.filterDeviceList) return '';

        var urlParts = this.filterDeviceList.url.split('&');
        urlParts = Misc.selectWhere(urlParts, function (item) {
            return item.substr(0, 6) != 'limit=' && item.substr(0, 7) != 'offset=';
        });
        var url = urlParts.join('&');

        return url + '&format=csv&caller=filter&filename=' + this.getCSVFileName();
    },

    getCSVFileName: function () {
        return encodeURI('devices_' + Misc.timestampFormat(new Date()) + '.csv');
    },

    getItemsPerPage: function () {
        return AppState.getItemsPerPage();
    },
});

module.exports = BaseFilterController;
